import { render } from "./ButtonMatch.vue?vue&type=template&id=7c2c4a4e&scoped=true"
import script from "./ButtonMatch.vue?vue&type=script&lang=js"
export * from "./ButtonMatch.vue?vue&type=script&lang=js"

import "./ButtonMatch.vue?vue&type=style&index=0&id=7c2c4a4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2c4a4e"]])

export default __exports__